import React, { useState } from 'react';
import { Form, Email, VALIDATION_STATES } from '@parchment/forms';
import { ValidationRequiredIcon, WarningIcon } from '@parchment/icons';
import { alto, Banner, Button, Heading4 as Heading4Raw, Loader, thunderBird, white } from '@parchment/atoms';
import styled from 'styled-components';
import { blackListedDomains } from '../common/constants/EmailDomainBlacklist';

const noop = () => {};
export default function LandingForm({
    isHighSchool = false,
    email = '',
    isSubmittingForm = false,
    onChange = noop,
    onSubmit = noop,
    validationState = VALIDATION_STATES.neutral
}) {
    const [ emailValidationState, setEmailValidationState ] = useState(validationState);
    const [ emailBlackListed, setEmailBlacklisted ] = useState(false);
    const buttonLabel = isSubmittingForm ? ( <Loader loading loadingMessage='Loading...' /> ): 'Continue';
    const buttonDisabled = isSubmittingForm || emailValidationState !== VALIDATION_STATES.success;

    const isBlackListedEmail = () => {
        const emailDomain = email.split('@')[1];
        if(!blackListedDomains.includes(emailDomain)) {
            onSubmit(email)
        } else {
            setEmailBlacklisted(true);
            setEmailValidationState(VALIDATION_STATES.error);
        }
    }

    const resetEmail = () => {
        setEmailBlacklisted(false);
        setEmailValidationState(VALIDATION_STATES.neutral);
        onChange('');
    }

    const renderBlackListedEmailMessage = () => {
        return (
            <Banner
                key='black-listed-email-message'
                icon={<WarningIcon />}
                title="Error"
                message={'Creating accounts from the provided email domain is not supported.'}
                context='error'
                dismissable
                onDismiss={() => resetEmail()}
                actionType={'button'}
                actionLabel={'Reset Email'}
                onAction={() => resetEmail()}
            />
        )
    }

    return (
        <FormSection>
            {emailBlackListed && renderBlackListedEmailMessage()}
            <Heading4 withExtraSpace>Start Here - Enter Your Email Address</Heading4>
            {isHighSchool && <>
                <StyledLink href={"/c/reg/regcode.php"}>Or Click Here if you have a Registration Code</StyledLink>
                <br/>
            </>
            }
            <Form className='email-check-form' onSubmit={() => isBlackListedEmail()}>

                <Email
                    id='user-email'
                    required={true}
                    internalLabel={true}
                    value={email || ''}
                    valid={emailValidationState}
                    onChange={(value) => onChange(value)}
                    onValidate={(validationState) => setEmailValidationState(validationState)}
                />
                <StyledButton id='continue-button-email-check' type='submit' context='primary'
                              name='continue-email-check' block
                              disabled={buttonDisabled}>{buttonLabel}</StyledButton>
            </Form>
            <FormNoteMessage>
                <RequiredIcon color={thunderBird} />
                <p>All items marked with a red asterisk are required</p>
            </FormNoteMessage>
        </FormSection>
    );
}

const FormSection = styled.div`
    > *:not(:first-child) {
        margin-top: 20px;
    }
`;
FormSection.displayName = 'FormSection';

const StyledLink = styled.a`
  text-align: right;
  float: right;
`;

const Heading4 = styled(Heading4Raw)`
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
`;
Heading4.displayName = 'Heading4';

const StyledButton = styled(Button)`
    margin-top: 20px;
`;

const RequiredIcon = styled(ValidationRequiredIcon)`
    height: 15px;
    width: 15px;
    border: 1px solid ${alto};
    background-color: ${white};
`;
RequiredIcon.displayName = 'RequiredIcon';

const FormNoteMessage = styled.div`
    display: flex;
    justify-content: center;

    p {
        font-size: 14px;
        font-weight: 600;
        margin: 0 0 0 15px;
    }
`;
FormNoteMessage.displayName = 'FormNoteMessage';
